// Thin fetch wrapper. Throws on non-2xx so callers can `.catch` uniformly.
export const API_BASE = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080';

async function handle<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(`API ${res.status}: ${body || res.statusText}`);
  }
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}

export async function apiGet<T>(path: string): Promise<T> {
  return handle<T>(await fetch(`${API_BASE}${path}`));
}

export async function apiPost<T>(path: string, body?: unknown): Promise<T> {
  return handle<T>(
    await fetch(`${API_BASE}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body === undefined ? undefined : JSON.stringify(body),
    }),
  );
}

export async function apiUpload<T>(path: string, file: File): Promise<T> {
  const form = new FormData();
  form.append('file', file);
  return handle<T>(await fetch(`${API_BASE}${path}`, { method: 'POST', body: form }));
}

export async function apiDelete<T>(path: string): Promise<T> {
  return handle<T>(await fetch(`${API_BASE}${path}`, { method: 'DELETE' }));
}
